export default __webpack_public_path__ + "static/szmigiel-2917f445b18f037a69622bfd31eb9360.jpg";